export function PhoneLink({ phone }) {
  if (!phone) return "—";
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length !== 10 || !digits.startsWith('0')) return phone;
  const display = `${digits.slice(0, 2)} ${digits.slice(2, 6)} ${digits.slice(6, 10)}`;
  const href = `tel:+61${digits.slice(1)}`;
  return (
    <a href={href} style={{ color: "inherit", textDecoration: "none" }}>
      {display}
    </a>
  );
}
